import GpsOffIcon from "@mui/icons-material/GpsOff";
import styles from "./Toast.module.scss";

const Toast = ({ message }: { message: string }) => (
  <div className={styles.toast}>
    <GpsOffIcon style={{ fontSize: 15 }} />
    {message}
  </div>
);

export default Toast;